import { ANALYTICS_TAB_INDEX } from "./constants";

import type { Filter } from "@/components/StructuredSearch/config";
import {
  getStructuredFilterTrackingProperties,
  serializeStructuredFilterForTracking,
  trackRequestsAnalyticsEvent,
} from "@/utils/requests-analytics-tracking";

export const getRequestsAnalyticsTabName = (tabIndex: number) => {
  if (tabIndex === ANALYTICS_TAB_INDEX) {
    return "Analytics";
  }
  return "Requests";
};

export const trackStructuredFilterCollectionChanges = ({
  currentFilters,
  previousFilters,
  selectedTabIndex,
}: {
  currentFilters: Filter[];
  previousFilters: Filter[];
  selectedTabIndex: number;
}) => {
  const previousSerializedFilters = new Set(
    previousFilters.map(serializeStructuredFilterForTracking),
  );
  const currentSerializedFilters = new Set(
    currentFilters.map(serializeStructuredFilterForTracking),
  );

  currentFilters.forEach(filter => {
    if (previousSerializedFilters.has(serializeStructuredFilterForTracking(filter))) {
      return;
    }

    trackRequestsAnalyticsEvent("Requests Analytics Filter Applied", {
      page: "Requests & Analytics",
      active_tab: getRequestsAnalyticsTabName(selectedTabIndex),
      ...getStructuredFilterTrackingProperties(filter),
      total_filter_count: currentFilters.length,
    });
  });

  previousFilters.forEach(filter => {
    if (currentSerializedFilters.has(serializeStructuredFilterForTracking(filter))) {
      return;
    }

    trackRequestsAnalyticsEvent("Requests Analytics Filter Removed", {
      page: "Requests & Analytics",
      active_tab: getRequestsAnalyticsTabName(selectedTabIndex),
      ...getStructuredFilterTrackingProperties(filter),
      total_filter_count: currentFilters.length,
    });
  });
};
